import { takeEvery, all, put, call } from "redux-saga/effects"
import { DckActionCreators, DckActionTypes } from "dck-redux"

import * as ItemTypes from "../../items/types"
import ProcessTypes from "../../processes/types"
import apiServerApi from "../apiServerApi"
import store from "store"
import { parseFetchError } from "../../../lib/utils"

/**
 * Save an APK to the api-server
 * @param {*} action 
 */
function* uploadUpdateSaga(action) {

  yield put({ type: DckActionTypes.ASYNC_PROCESS_START, processCode: ProcessTypes.UPLOAD_UPDATE })
  let processResult

  try {

    const state = store.get("sessionData"),
    result = yield call(apiServerApi.uploadUpdate, state.access_token, action.data)

    if(result.code !== 200) {
      const err = result.message + (result.body && typeof result.body === 'string' ? ' ' + result.body : '')
      throw err
    }
    processResult = { success: true, message: null }
    yield put(DckActionCreators.itemsLoad(ItemTypes.Update))
  }
  catch(error) {
    processResult = { success: false, message: parseFetchError(error).text }
  }

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_STOP,
    processCode: ProcessTypes.UPLOAD_UPDATE,
    result: processResult
  })
}

function* updateList() {

  try {
    const state = store.get("sessionData"),
    response = (yield call(apiServerApi.getAllUpdates, state.access_token)).body
    yield put({
      type: DckActionTypes.ITEMS_SET,
      itemType: ItemTypes.Update,
      data: response
    })
  }
  catch (e) {
    console.error(e)
  }
}

function* updatesSaga() {
  yield all([
    takeEvery(
      action => action.type === DckActionTypes.ITEM_ADD && action.itemType === ItemTypes.Update,
      uploadUpdateSaga
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEMS_LOAD &&
        action.itemType === ItemTypes.Update,
      updateList
    ),
  ])
}

export default updatesSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/items/updates.js